<!-- <button class="changeUnit" style="position: fixed;
left: 0;
background: red;
z-index: top;
z-index: 1000000000;" (click)="changeUnitToShow('pZLV6FzLEDsLWt7', 3)">AAAAAAAA</button>
<button class="changeUnit" style="position: fixed;
left: 0;
background: red;
top:4rem;
z-index: top;
z-index: 1000000000;" (click)="changeUnitToShow('OXMwZtbVweQjPVD', 10)">BBBBBBBBBBBBB</button> -->
<!-- <app-test-menu (projPassToParent)='projPassFromMenu($event)'></app-test-menu> -->

<div *ngIf="appartmentsIdArray.length > 1" class="appartment-menu">
  <span href="javascript:;" class="menu-item title-button project-list"> רשימת הנכסים</span>
  <ul>
    <li *ngFor="let item of appartmentsIdArray">
      <a href="javascript:;" (click)="changeUnitToShow(item.building, item.number)">{{
        item.number }}</a>
    </li>
  </ul>
</div>

<div *ngIf="items" class="flat-properties-holder">
  <div *ngIf="this.illustrationOnly" class="illustration-only"><span
      *ngIf="!this.illustrationOnlyNote || !desktopResolution">{{ 'ILLUSTRATION-ONLY' | translate }}</span>
    <span class="illustration-only-note" *ngIf="this.illustrationOnlyNote">{{ this.illustrationOnlyNote | translate
      }}</span>
  </div>
  <!-- <div class="proj-comp-titles">
    <app-gallery [galleryId]="'1'" [section]="compId + 'imagesCompLogo'" [autoPlay]="false"
      [showThumbs]="false" class="logo-img comp-logo"></app-gallery>
    <app-gallery [galleryId]="'1'" [section]="projUid+'menuLogo'" [autoPlay]="false" [showThumbs]="false"
      class="logo-img top-project-menu-logo"></app-gallery>
  </div> -->
  <div class="image-holder image-with-staus" *ngIf="this.contactPhoneNumber">
    <!-- <div class="image-holder image-with-staus" *ngIf="this.user.phoneNumber && removeAllMenu === 'true'"> -->
    <span class="inner-image-holder" *ngIf="this.buildUid">
      <img src="this.user.photoURL" alt="">
      <app-gallery [galleryId]="'1'" [section]="this.buildUid +'contactMenPic'" [autoPlay]="false" [showThumbs]="false"
        class="contact-men-pic"></app-gallery>
    </span>
    <div class="buttons-holder">
      <div class="contact-men"> לשאול את {{ contactName }}</div>
      <!-- <div class="contact-men"> לשאול את {{ this.user.displayName }}</div> -->
      <a class="whatsapp" href="https://api.whatsapp.com/send?phone={{ contactPhoneNumber }}" target="_blank"></a>
      <!-- <a class="whatsapp" href="https://api.whatsapp.com/send?phone={{ this.user.phoneNumber }}" target="_blank"></a> -->
      <a class="phone" href="tel:{{ contactPhoneNumber }}"></a>
      <!-- <a class="phone" href="tel:{{ this.user.phoneNumber }}"></a> -->
    </div>
  </div>
  <a *ngIf="!removeCloseButton" class="close-section close-fixed close-display" href="javascript:;"
    (click)="goToBuilding()"></a>

  <input type="text" [value]="routeNavigate" class="hide-url" #userinput>
  <button *ngIf="removeAllMenu === 'false' && !unika" (click)="copyInputMessage(userinput)" class="share-url"></button>
  <div *ngIf="this.user && !unika && removeAllMenu === 'false'">
    <button *ngIf="this.user.roles.editor && this.user.compId === this.compId || this.user.roles.admin"
      (click)="openDialog()" class="offer-btn"></button>
  </div>

  <!-- <mat-form-field appearance="fill" >
      <mat-label>What's your name?</mat-label>
    </mat-form-field> -->
  <!-- <a class="fa-whatsapp share-whatsapp" href="https://api.whatsapp.com/send?&text={{ routeNavigate + '?m=all' }}" target="_blank"></a> -->

  <a *ngIf="removeAllMenu === 'false' && !unika" class="fa-whatsapp share-whatsapp">
    <div class="whatsapp-menu-trigger" (click)="showPhoneF()">
      <ul class="whatsapp-menu" *ngIf="showPhone">
        <li (click)="showPhoneNumber = !showPhoneNumber"><a href="javascript:;">{{ 'PHONE-NUMBER' | translate }}</a>
        </li>
        <li><a href="https://api.whatsapp.com/send?&text={{ routeNavigate + '?m=all' }}" target="_blank">{{ 'USER-LIST'
            | translate }}</a></li>
      </ul>
    </div>

    <div class="add-phone-numbrer" *ngIf="showPhoneNumber">
      <mat-form-field appearance="fill">
        <select class="area-code" matNativeControl required (change)="onChangeAreaCode($event.value)">
          <option type="number" *ngFor="let code of areaCodes" value="{{ code }}">{{ code
            }}
          </option>
        </select>
      </mat-form-field>

      <input [(ngModel)]='phoneNumber' type="number" pattern="/[^\d+]/" placeholder="050 1111111" name="phone-number">
      <a class="btn"
        href="https://api.whatsapp.com/send?text={{ routeNavigate + '?m=all' + '&phone='+ areaCode + phoneNumber }}"
        target="_blank">שלח</a>
    </div>
  </a>

  <span *ngIf="!unika" class="show-coppy-note" [class.active]=showCopyNote>{{ 'COPIED' | translate }}</span>

  <!-- 
  <div class="share-button-holder" *ngIf="unika">


    <input type="text" [value]="routeNavigate" class="hide-url" #userinput>
    <a *ngIf="removeAllMenu === 'false'" class="fa-whatsapp share-whatsapp">
      <div class="whatsapp-menu-trigger" (click)="showPhoneF()">
        <ul @slideUp class="whatsapp-menu" *ngIf="showPhone">
          <li (click)="showPhoneNumber = !showPhoneNumber"><a href="javascript:;">
              <div class="text phone"></div>
              <div class="title">{{ 'PHONE-NUMBER' | translate }}</div>
            </a></li>
          <li><a href="https://api.whatsapp.com/send?&text={{ routeNavigate }}" target="_blank">
              <div class="text list-users"></div>
              <div class="title">{{ 'USER-LIST' | translate }}</div>
            </a></li>
        </ul>
      </div>

      <div @slideUp class="add-phone-numbrer" *ngIf="showPhoneNumber">
        <mat-form-field appearance="fill">
          <select class="area-code" matNativeControl required (change)="onChangeAreaCode($event.value)">
            <option type="number" *ngFor="let code of areaCodes" value="{{ code }}">{{ code
              }}
            </option>
          </select>
        </mat-form-field>

        <input [(ngModel)]='phoneNumber' type="number" pattern="/[^\d+]/" placeholder="050 1111111" name="phone-number">
        <textarea [(ngModel)]='freeText' type="text" placeholder="{{ 'FREE-TEXT' | translate }}"
          name="free-text"></textarea>
        <a class="btn" *ngIf="!sehelUser"
          href="https://api.whatsapp.com/send?text={{freeText + '%0a' + this.titleWhatsapp + '%0a' + textWhatsapp1 + '%0a' +  routeNavigate + '%0a' + '%0a'+ textWhatsapp2 +'%0a'+ this.projTile +'%0a'+ '&phone='+ areaCode + phoneNumber }}"
          target="_blank">שלח</a>
        <a class="btn sehel" *ngIf="sehelUser" (click)="sendWhatsapSehel(phoneNumber)" href="javascript:;">שלח</a>
      </div>
    </a>


    <button *ngIf="removeAllMenu === 'false'" (click)="copyInputMessage(userinput)" class="share-url"></button>
    <div *ngIf="this.user" class="offer-holder">
      <button *ngIf="this.user.roles.editor && this.user.compId === this.compId || this.user.roles.admin"
        (click)="openDialog()" class="offer-btn"></button>
    </div>

    <span class="show-coppy-note" [class.active]=showCopyNote>{{ 'COPIED' | translate }}</span>


  </div> -->



  <div *ngFor="let flatPropertie of flatProperties" class="flat-properties-container"
    [class.no-menu]="removeAllMenu === 'true'">
    <div class="flat-properties-title" *ngIf="compositeDesign && !unika">
      <span *ngIf="withBuilding">{{ 'BUILDING' | translate }}:</span>
      <div *ngIf="withBuilding">{{ buildName }}</div> <span *ngIf="flat.number && withBuilding">{{ 'FLAT-NUMBER' |
        translate }}:</span> {{ flat.number }}
    </div>
    <div class="flat-details-holder">
      <!-- <h3 class="title">פרטי דירה</h3> -->
      <div *ngIf="items;else noItems" class="list-flats flat-composite-padding">
        <div *ngFor="let item of items" class="collection" class="flat dark-background">
          <ul class="general-flat-propeties" *ngIf="!compositeDesign">
            <li class="general-flat-building">{{ buildName }}</li>
            <li class="general-UNIT-NAME"> <span>{{ 'UNIT-NAME' | translate }}</span> {{ item.number }}
              <div class="app-name"
              *ngIf="item.name !== 0 || item.name">{{ item.name }}</div>
            </li>
            <li class="general-flat-floor-number"> <span>{{ 'FLOOR' | translate }}</span> {{ item.floorNumber }}</li>
            <li class="general-flat-area">
              <span>{{ 'UNIT-SQUARE-METER' | translate }}</span> <div *ngIf="this.wholeNum">{{ flatPropertie.flatSize | wholeNum }}</div>
              <div *ngIf="!this.wholeNum">{{ flatPropertie.flatSize }}</div> 
            </li>
            <li *ngIf="buildType !== 'office'" class="general-flat-room-quantity numberOfRooms-title">
              <span>{{ 'ROOM-QUANTITY' | translate }}</span> {{ flatPropertie.numberOfRooms }}
            </li>
          </ul>
          <ul class="general-flat-propeties n" *ngIf="compositeDesign" (click)="justOpenMenuMatTab()">
            <!-- <li *ngIf="!unika"><a *ngIf="compositeDesign" class="close right-long-arrow" href="javascript:;"
                (click)='closeFlatProperties()'><span></span></a></li> -->
            <li *ngIf="unika && !hideRightMenu" class="general-flat-building">{{ buildName }} <a *ngIf="compositeDesign"
                class="close right-long-arrow" href="javascript:;" (click)='closeFlatProperties()'><span></span></a>
            </li>
            <li *ngIf="unika" class="general-UNIT-NAME UNIT-NAME-title"> <span>{{ 'UNIT-NAME' | translate
                }}</span> {{ item.number }}
                            <div class="app-name"
                            *ngIf="item.name !== 0 || item.name">{{ item.name }}</div>
              </li>
            <li *ngIf="item.airDirection" class="general-flat-air-direction air-direction-title"><span>{{
                'AIR-DIRECTION' | translate
                }}</span><div class="airdir">{{ item.airDirection }}</div>
            </li>
            <!-- <li *ngIf="item.number" class="general-UNIT-NAME"> <span>{{ 'UNIT-NAME' | translate }}</span> {{ item.number }}</li> -->
            <li *ngIf="item.floorNumber && !item.floorTitle && buildType !== 'office'" class="general-flat-floor-number floor-title"> <span>{{
                'FLOOR' | translate
                }}</span> {{
              item.floorNumber }}
            </li>
            <li *ngIf="item.floorTitle && buildType !== 'office'" class="general-flat-floor-number floor-title"> <span>{{ 'FLOOR' | translate
                }}</span> {{ item.floorTitle }}
            </li>

            <li *ngIf="flatPropertie.flatSize" class="general-flat-area flat-size-title">
              <span>{{ 'UNIT-SQUARE-METER' | translate }}</span> <div *ngIf="this.wholeNum">{{ flatPropertie.flatSize | wholeNum }}</div>
              <div *ngIf="!this.wholeNum">{{ flatPropertie.flatSize }}</div> 
            </li>
            <li *ngIf="flatPropertie.shelterArea && +flatPropertie.shelterArea > 0" class="general-flat-area flat-size-title">
              <span> {{ 'SHELTER-SQUARE-METER' | translate }} </span> <div>{{ flatPropertie.shelterArea }}</div>
            </li>
            <li *ngIf="flatPropertie.balconiesSize" class="general-flat-area flat-size-title">
              <span>{{ 'BALCONY-SQUARE-METER' | translate }}</span>
              <div *ngIf="this.wholeNum">{{ flatPropertie.balconiesSize | wholeNum }}</div>
              <div *ngIf="!this.wholeNum">{{ flatPropertie.balconiesSize }}</div>
            </li>
            <li *ngIf="flatPropertie.gardenSize" class="general-flat-area balconies-size-title">
              <span>{{ 'GARDEN-AREA' | translate }}</span> 
              <div *ngIf="this.wholeNum">{{ flatPropertie.gardenSize | wholeNum }}</div>
              <div *ngIf="!this.wholeNum">{{ flatPropertie.gardenSize }}</div>
            </li>
            <li *ngIf="flatPropertie.numberOfRooms && buildType !== 'office'" class="general-flat-room-quantity numberOfRooms-title">
              <span>{{ 'ROOM-QUANTITY' | translate }}</span> {{ flatPropertie.numberOfRooms }}
            </li>
          </ul>
          <!-- בניין: {{ buildName }}
        מספר דירה: {{ item.number }}
        קומה: {{ item.floorNumber }} -->

        </div>
      </div>
      <div *ngFor="let item of items">
        <!-- {{ item.shareflatgallery }} {{ this.projUid }} -->
        <app-gallery *ngIf="item.shareflatgallery && !compositeDesign" [galleryId]="'1'"
          [section]="projUid+'interiorSimulations'" [autoPlay]="false" [showThumbs]="true"
          class="list-static flat-details shared-flat-gallery"></app-gallery>

        <app-gallery *ngIf="item.shareflatgalleryOfBuilding  && !compositeDesign"
          [class.full-screen-view]="fullScreenGallery" [galleryId]="'1'" [section]="buildUid+'interiorSimulations'"
          [autoPlay]="true" [showThumbs]="true" (isNoItems)="isNoItemsF($event, 'shareflatgalleryOfBuilding')"
          class="list-static flat-details shared-flat-gallery scroll"></app-gallery>
      </div>
      <app-gallery *ngIf="!compositeDesign" [galleryId]="'1'" [section]="flatPropertie.id+'interiorSimulations'"
        [autoPlay]="false" [showThumbs]="true" class="list-static flat-details"></app-gallery>
      <div *ngIf="flatPropertie.freeText && flatPropertie.freeText !== ' ' && !compositeDesign"
        class="flat-properties dark-background">
        <h3 class="title second-title slide" [class.active]="slide" (click)="slide = !slide">
          {{ 'SPECIFICATION' | translate }}</h3>
        <ul [class.active]="showContent" class="flat-details-content">
          <li [innerHtml]="flatPropertie.freeText | safe: 'html'">

          </li>
        </ul>
        <!-- <button class="read-more" [class.hide]="slide">קראה עוד</button> -->
      </div>
      <!-- <div>
            <h4 (click)="showContent = !showContent">מפרט טכני</h4>
          </div>
          <ul [class.active]="showContent" class="flat-details-content">
            <li [innerHtml]="flatPropertie.freeText | safe: 'html'">
    
            </li>
          </ul> -->
      <!-- </div> -->
      <!-- <div *ngIf="editState && itemToEdit.id == flatPropertie.id" class="files"> -->
      <div class="display-flex-row" *ngIf="!compositeDesign">
        <div *ngIf="items;else noItems" class="view-from-floor">
          <h3 _ngcontent-xci-c169="" class="title second-title ng-tns-c169-7">{{ 'VIEW-FROM-THE-FLOOR' | translate }}
          </h3>
          <div *ngFor="let item of items" class="collection" class="panorama-holder"
            [class.full-screen-view]="fullScreenSpirical">
            <!-- <div class="view-from-floor-panorama-holder" [innerHtml]="this.proj[0].spirical | safe: 'html'"></div> -->
            <!-- <h1>{{ this.proj[0].spirical }}</h1> -->
            <!-- <div *ngIf="this.illustrationOnly" class="illustration-only"><span *ngIf="!this.illustrationOnlyNote">{{ 'ILLUSTRATION-ONLY' | translate }}</span>
                <span *ngIf="this.illustrationOnlyNote">{{ this.illustrationOnlyNote | translate }}</span>
              </div> -->
            <div *ngIf="this.mainSpiricalSrcUpdated" class="view-from-floor-panorama-holder"
              [innerHtml]="'<iframe src=' + this.mainSpiricalSrc + '?s=' + item.curFloorPanorama + '></iframe>' | safe: 'html'">
            </div>

            <!-- ?s=pano45  parametr  -->
            <div class="fullscreen-big-button" [class.active]="fullScreenSpirical" (click)="bigSpirical()">
              <ul class="fullscreen" [class.fullscreenShow]="fullScreenSpirical">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
              <span *ngIf=!fullScreenSpirical> {{ 'ENLARGEMENT' | translate }} </span>
              <span *ngIf=fullScreenSpirical> {{ 'REDUCTION' | translate }} </span>
            </div>
          </div>
        </div>


        <div *ngIf="items && this.flatProperties[0].flatInterior" class="view-from-floor">
          <h3 _ngcontent-xci-c169="" class="title second-title ng-tns-c169-7">{{ 'FLAT-INTERIOR' | translate }}</h3>
          <div *ngFor="let item of items" class="collection" class="panorama-holder"
            [class.full-screen-view]="fullScreenInterior">
            <!-- <div *ngIf="this.illustrationOnly" class="illustration-only">{{ 'ILLUSTRATION-ONLY' |
                translate }}</div> -->

            <!-- <div *ngIf="this.illustrationOnly" class="illustration-only"><span *ngIf="!this.illustrationOnlyNote">{{ 'ILLUSTRATION-ONLY' | translate }}</span>
                  <span *ngIf="this.illustrationOnlyNote">{{ this.illustrationOnlyNote | translate }}</span>
                </div>   -->
            <div class="view-from-floor-panorama-holder flat-interior"
              [innerHtml]="'<iframe src=' + this.flatProperties[0].flatInterior + '></iframe>' | safe: 'html'">
            </div>
            <div class="fullscreen-big-button" [class.active]="fullScreenInterior" (click)="bigInterior()">
              <ul class="fullscreen" [class.fullscreenShow]="fullScreenInterior">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
              <span *ngIf=!fullScreenSpirical> {{ 'ENLARGEMENT' | translate }} </span>
              <span *ngIf=fullScreenSpirical> {{ 'REDUCTION' | translate }} </span>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div class="flat-details-drawing" *ngIf="!compositeDesign">
      <div class="">
        <div class="drawing" [class.full-screen-view-title]="fullScreenDrawing" href="javascript:;">
          <h3 class="title second-title">{{ 'FLAT-PLAN' | translate }}</h3>
        </div>
        <!-- <a class="close fa fa-times-circle fa-lg" href="javascript:;" (click)='closeGal()'></a> -->

        <app-gallery [galleryId]="'1'" [section]="flatPropertie.id+'images'" [resizeDrag]="true" [autoPlay]="true"
          [showThumbs]="true" class="list-static simple-gall build-simple-gal plan-holder"
          [class.full-screen-view]="fullScreenDrawing"></app-gallery>
      </div>
      <div class="fullscreen-big-button" [class.active]="fullScreenDrawing" (click)="bigDrawing()">
        <ul class="fullscreen" [class.fullscreenShow]="fullScreenDrawing">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <span *ngIf=!fullScreenDrawing> {{ 'ENLARGEMENT' | translate }} </span>
        <span *ngIf=fullScreenDrawing> {{ 'REDUCTION' | translate }} </span>
      </div>
    </div>

    <div *ngIf="compositeDesign" class="flat-composite-padding flat-composite-bottom">
      <div *ngIf="flatPropertie.freeText && flatPropertie.freeText !== ' ' && !unika"
        class="flat-properties dark-background">
        <h3 *ngIf="!compositeDesign" class="title second-title slide" [class.active]="slide" (click)="slide = !slide">
          {{ 'SPECIFICATION' | translate }}</h3>
        <h3 *ngIf="compositeDesign" class="title second-title slide" (click)="fullScreen = !fullScreen"
          [class.full-screen-view]="fullScreen">{{ 'SPECIFICATION' | translate }}
          <div class="increase-size">
            <span></span>
          </div>
        </h3>
        <div class="scroll-holder" *ngIf="!compositeDesign">
          <ul [class.active]="showContent" class="flat-details-content">
            <li [innerHtml]="flatPropertie.freeText | safe: 'html'">

            </li>
          </ul>
        </div>

        <div class="scroll-holder specification-holder" *ngIf="compositeDesign" [class.full-screen-view]="fullScreen">
          <ul [class.active]="showContent" class="flat-details-content">
            <li [innerHtml]="flatPropertie.freeText | safe: 'html'">

            </li>
          </ul>
        </div>
      </div>


      <mat-tab-group mat-align-tabs="start" [class.active]="toggleMenuTab" [class.change-place]="propertiesMenuChangePlace">
        <div *ngFor="let item of items">
          <mat-tab *ngIf="this.building.hdr">
            <ng-template mat-tab-label>
              <div class="lable-holder" (click)="openMenuMatTab()">
                <mat-icon class="3d-icon"></mat-icon>
                <!-- {{ 'INTERIOR-TOUR' | translate }} -->
                3D
              </div>
            </ng-template>
            <div class="3d-flat-holder">
              <!-- <app-threejs *ngIf="ifThree" [currentBuilding]="this.build"></app-threejs> -->
              <app-threejs *ngIf="ifThree" [flat]="this.item" [currentBuilding]="this.building"></app-threejs>

            </div>
          </mat-tab>

          <mat-tab *ngIf="withDrawing">
            <ng-template mat-tab-label>
              <div class="lable-holder" (click)="openMenuMatTab('plan')">
                <mat-icon class="plan-icon"></mat-icon>
                {{ 'FLOOR-PLAN' | translate }}
              </div>
            </ng-template>

            <!-- <app-drawing-floors class="floor-gallery"
              [drawingHolderWidth]="1000" [item]="this.curFloorId"></app-drawing-floors> -->
              <app-gallery *ngIf="!ifFloorIdIsFloorNumber(this.curFloorId)" [galleryId]="'1'" [section]="this.curFloorId+'floordrawing-SVG'" [autoPlay]="true"
              [showThumbs]="true"
              class="list-static test1 simple-gall svg-gallery build-simple-gal plan-holder"></app-gallery>

              <app-gallery *ngIf="ifFloorIdIsFloorNumber(this.curFloorId)" [galleryId]="'1'" [section]="this.curFloorId+'floordrawing-SVG'+buildUid" [autoPlay]="true"
              [showThumbs]="true"
              class="list-static test2 simple-gall svg-gallery build-simple-gal plan-holder"></app-gallery>
  
              <app-gallery *ngIf="!ifFloorIdIsFloorNumber(this.curFloorId)" [galleryId]="'1'" [section]="this.curFloorId+'floordrawing'" [autoPlay]="true"
                [showThumbs]="true" [resizeDrag]="true"
                class="list-static simple-gall simple-floor-plan build-simple-gal plan-holder"></app-gallery>

              <app-gallery *ngIf="ifFloorIdIsFloorNumber(this.curFloorId)" [galleryId]="'1'" [section]="this.curFloorId+'floordrawing'+buildUid" [autoPlay]="true"
               [showThumbs]="true" [resizeDrag]="true"
               class="list-static simple-gall simple-floor-plan  build-simple-gal plan-holder"></app-gallery>

            <!-- <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigDrawing()">
              <span></span>
            </div> -->
          </mat-tab>

          <mat-tab *ngIf="this.flatProperties[0].flatInterior">
            <ng-template mat-tab-label>
              <div class="lable-holder" (click)="openMenuMatTab()">
                <mat-icon class="interior-pano-icon"></mat-icon>
                {{ 'INTERIOR-TOUR' | translate }}
              </div>
            </ng-template>
            <div class="panorama-holder" [class.full-screen-view]="fullScreenInterior">
              <!-- <div *ngIf="this.illustrationOnly" class="illustration-only">{{ 'ILLUSTRATION-ONLY' |
                  translate }}</div> -->
              <!-- <div *ngIf="this.illustrationOnly" class="illustration-only"><span *ngIf="!this.illustrationOnlyNote">{{ 'ILLUSTRATION-ONLY' | translate }}</span>
                    <span *ngIf="this.illustrationOnlyNote">{{ this.illustrationOnlyNote | translate }}</span>
                  </div> -->
              <div class="view-from-floor-panorama-holder flat-interior"
                [innerHtml]="'<iframe src=' + this.flatProperties[0].flatInterior + '></iframe>' | safe: 'html'">
              </div>
            </div>
            <!-- <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigInterior()">
              <span></span>
            </div> -->
          </mat-tab>

          <mat-tab *ngIf="!desktopResolution && hide360PanoInFlat">
            <ng-template mat-tab-label>
              <div class="lable-holder" (click)="openMenuMatTab()">
                <mat-icon class="spirikal-pano-icon"></mat-icon>{{ 'SPIRIKAL' | translate }}
              </div>
            </ng-template>
            <div class="collection da-iframe panorama-holder">
              <!-- <div *ngIf="this.illustrationOnly" class="illustration-only">{{ 'ILLUSTRATION-ONLY' |
                  translate }}</div> -->
              <!-- <div *ngIf="this.illustrationOnly" class="illustration-only"><span *ngIf="!this.illustrationOnlyNote">{{ 'ILLUSTRATION-ONLY' | translate }}</span>
                    <span *ngIf="this.illustrationOnlyNote">{{ this.illustrationOnlyNote | translate }}</span>
                  </div> -->
              <div *ngIf="this.mainSpiricalSrcUpdated" class="view-from-floor-panorama-holder"
                [innerHtml]="'<iframe src=' + this.mainSpiricalSrc + '></iframe>' | safe: 'html'">
              </div>
            </div>
            <!-- <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigSpirical()">
              <span></span>
            </div> -->
          </mat-tab>


          <mat-tab *ngIf="plan || flatPropertie.sPlaneUrl">
            <ng-template mat-tab-label>
              <div class="lable-holder" (click)="openMenuMatTab('plan')">
                <mat-icon class="plan-icon"></mat-icon>
                {{ 'PLAN' | translate }}
              </div>
            </ng-template>
            <app-gallery [galleryId]="'1'" [section]="flatPropertie.id+'images'" [resizeDrag]="true" [autoPlay]="true"
              [showThumbs]="true" class="list-static simple-gall build-simple-gal plan-holder"
              [class.full-screen-view]="fullScreenDrawing"></app-gallery>

            <app-gallery *ngIf="flatPropertie.sPlaneUrl" [galleryId]="'1'" [section]="flatPropertie.sPlaneUrl"
              [resizeDrag]="true" [autoPlay]="true" [showThumbs]="true"
              class="list-static simple-gall build-simple-gal plan-holder sPlaneUrl"
              [class.full-screen-view]="fullScreenDrawing">
            </app-gallery>
            <div *ngIf="flatPropertie.planeUrl" class="draggable-holder">
              <div draggable>
                <pinch-zoom>
                  <img [src]="flatPropertie.planeUrl" id="drag-element" />
                </pinch-zoom>
              </div>
            </div>
            <!-- <div class="stream-image-sehel" *ngIf="flatPropertie.sPlaneUrl"
                  [innerHtml]="'<img src='+ flatPropertie.planeUrl +'></img>' | safe: 'html'">
                </div> -->
            <!-- planeUrl -->

            <app-gallery *ngIf="flatPropertie.protoId" [galleryId]="'1'" [section]="flatPropertie.protoId+'images'"
              [resizeDrag]="true" [autoPlay]="true" [showThumbs]="true" (isNoItems)="isNoItemsF($event, 'plan')"
              class="list-static simple-gall build-simple-gal plan-holder sPlaneUrl"
              [class.full-screen-view]="fullScreenDrawing">
            </app-gallery>


            <!-- <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigDrawing()">
              <span></span>
            </div> -->
          </mat-tab>

          <mat-tab *ngIf="item.curFloorPanorama">
            <ng-template mat-tab-label>
              <div class="lable-holder" (click)="openMenuMatTab()">
                <mat-icon class="floor-pano-icon"></mat-icon>
                {{ 'VIEW' | translate }}
              </div>
            </ng-template>

            <!-- <mat-tab label="נוף"> -->
            <div class="collection" class="panorama-holder" [class.full-screen-view]="fullScreenSpirical">
              <!-- <div *ngIf="this.illustrationOnly" class="illustration-only">{{ 'ILLUSTRATION-ONLY' |
                  translate }}</div> -->
              <!-- <div *ngIf="this.illustrationOnly" class="illustration-only"><span *ngIf="!this.illustrationOnlyNote">{{ 'ILLUSTRATION-ONLY' | translate }}</span>
                    <span *ngIf="this.illustrationOnlyNote">{{ this.illustrationOnlyNote | translate }}</span>
                  </div> -->
              <div *ngIf="this.mainSpiricalSrcUpdated && !this.isUrl" class="view-from-floor-panorama-holder"
                [innerHtml]="'<iframe src=' + this.mainSpiricalSrc + '?s=' + item.curFloorPanorama  + '&start_hlookat=' + this.airDirectionDeg + '></iframe>' | safe: 'html'">
              </div>
              <div *ngIf="this.mainSpiricalSrcUpdated && this.isUrl" class="view-from-floor-panorama-holder"
                [innerHtml]="'<iframe src=' + item.curFloorPanorama + '&start_hlookat=' + this.airDirectionDeg + '></iframe>' | safe: 'html'">
              </div>
            </div>
            <!-- <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigSpirical()">
              <span></span>
            </div> -->
          </mat-tab>





          <mat-tab *ngIf="item.editionalGalTitle">
            <ng-template mat-tab-label>
              <div class="lable-holder" (click)="openMenuMatTab()">
                <mat-icon class="plan-icon"></mat-icon>
                {{ item.editionalGalTitle }}
              </div>
            </ng-template>

            <app-gallery *ngIf="item.editionalGalTitle" [galleryId]="'1'"
              [section]="item.editionalGalTitle+'-editionalGal'" [autoPlay]="true" [resizeDrag]="true"
              [showThumbs]="true" [class.full-screen-view]="fullScreenDrawing"
              class="list-static simple-gall build-simple-gal plan-holder"></app-gallery>


            <!-- <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigDrawing()">
              <span></span>
            </div> -->
          </mat-tab>


          <mat-tab *ngIf="shareflatgallery || simpleGallery">
            <ng-template mat-tab-label>
              <div class="lable-holder" (click)="openMenuMatTab('gal')">
                <mat-icon class="simulation-icon"></mat-icon>
                {{ 'SIMULATIONS' | translate }}
              </div>
            </ng-template>
            <app-gallery *ngIf="item.shareflatgallery" [class.full-screen-view]="fullScreenGallery" [galleryId]="'1'"
              [class.fixTranslate]="this.galCounter > 1" [section]="projUid+'interiorSimulations'" [autoPlay]="true"
              [showThumbs]="true" (isNoItems)="isNoItemsF($event, 'shareflatgallery')"
              class="list-static flat-details shared-flat-gallery scroll">
            </app-gallery>
            <app-gallery *ngIf="item.shareflatgalleryOfBuilding" [class.full-screen-view]="fullScreenGallery"
              [class.fixTranslate]="this.galCounter > 2" [galleryId]="'1'" [section]="buildUid+'interiorSimulations'"
              [autoPlay]="true" [showThumbs]="true" (isNoItems)="isNoItemsF($event, 'shareflatgalleryOfBuilding')"
              class="list-static flat-details shared-flat-gallery scroll">
            </app-gallery>

            <app-gallery [galleryId]="'1'" [class.full-screen-view]="fullScreenGallery"
              [class.fixTranslate]="this.galCounter > 2" [section]="flatPropertie.id+'interiorSimulations'"
              [autoPlay]="true" [showThumbs]="true" class="list-static flat-details scroll"
              (isNoItems)="isNoItemsF($event, 'simpleGallery')"></app-gallery>

            <app-gallery *ngIf="flatPropertie.protoId" [galleryId]="'1'" [class.full-screen-view]="fullScreenGallery"
              [class.fixTranslate]="this.galCounter > 2" [section]="flatPropertie.protoId+'interiorSimulations'"
              [autoPlay]="true" [showThumbs]="true" class="list-static flat-details scroll"
              (isNoItems)="isNoItemsF($event, 'simpleGallery')"></app-gallery>

            <!-- <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigGallery()">
              <span></span>
            </div> -->
          </mat-tab>

          <mat-tab *ngIf="desktopResolution && hide360PanoInFlat">
            <ng-template mat-tab-label>
              <div class="lable-holder" (click)="openMenuMatTab()">
                <mat-icon class="spirikal-pano-icon"></mat-icon>{{ 'SPIRIKAL' | translate }}
              </div>
            </ng-template>
            <div class="collection da-iframe panorama-holder">
              <!-- <div *ngIf="this.illustrationOnly" class="illustration-only">{{ 'ILLUSTRATION-ONLY' |
                  translate }}</div> -->
              <!-- <div *ngIf="this.illustrationOnly" class="illustration-only"><span *ngIf="!this.illustrationOnlyNote">{{ 'ILLUSTRATION-ONLY' | translate }}</span>
                    <span *ngIf="this.illustrationOnlyNote">{{ this.illustrationOnlyNote | translate }}</span>
                  </div> -->
              <div *ngIf="this.mainSpiricalSrcUpdated" class="view-from-floor-panorama-holder"
                [innerHtml]="'<iframe src=' + this.mainSpiricalSrc + '></iframe>' | safe: 'html'">
              </div>
            </div>
            <!-- <div class="increase-size" [class.active]="fullScreenDrawing" (click)="bigSpirical()">
              <span></span>
            </div> -->
          </mat-tab>

          <mat-tab *ngIf="flatPropertie.freeText && flatPropertie.freeText !== ' '">
            <ng-template mat-tab-label>
              <div class="lable-holder" (click)="openMenuMatTab()">
                <mat-icon class="flat-properties-icon"></mat-icon>
                {{ 'SPECIFICATION' | translate }}
              </div>
            </ng-template>
            <div class="flat-properties dark-background">
              <ul class="flat-details-content active">
                <li [innerHtml]="flatPropertie.freeText | safe: 'html'">

                </li>
              </ul>
              <!-- <button class="read-more" [class.hide]="slide">קראה עוד</button> -->
            </div>
          </mat-tab>

          <mat-tab *ngIf="this.aboutProjectShow">
            <ng-template mat-tab-label>
              <div class="lable-holder" (click)="openMenuMatTab()">
                <mat-icon class="flat-properties-icon"></mat-icon>
                {{ "ABOUT-PROJECT" | translate }}
              </div>
            </ng-template>
            <div class="about-project dark-background">
              <app-gallery [galleryId]="'1'" [section]="projUid + 'about-project'" [autoPlay]="true"
                [showThumbs]="false" class="list-static flat-details shared-flat-gallery scroll"
                [class.full-screen-view]="fullScreenDrawing"></app-gallery>
            </div>
          </mat-tab>

          <!-- <mat-tab>
              <ng-template mat-tab-label>
                <div class="lable-holder">
                  <mat-icon class="flat-properties-icon"></mat-icon>
                  {{ 'MAP' }}</div>
              </ng-template>
              <div class="flat-properties dark-background">
                <agm-map @slideRight [latitude]="32" [longitude]="35" [zoom]="+10"  id="mapRef">
                  <agm-marker *ngFor="let item of items" [latitude]="+item.lat"
                      [longitude]="+item.lng" class="marker-holder">
                  </agm-marker>
              </agm-map>
  
              <app-nearby-on-map></app-nearby-on-map>
              </div>
            </mat-tab> -->

        </div>
      </mat-tab-group>




    </div>
  </div>


</div>


<ng-template #noItems>
</ng-template>